import { LegalLinks } from '@updatecore/legal';
import { pick_locale } from '../i18n/translations';
import type { ReactNode } from 'react';

/** Props for the {@link CeremonyChrome} wrapper. */
interface CeremonyChromeProps {
  /** Heading shown at the top of the ceremony card. */
  title: string;
  /** Ceremony content rendered inside the card. */
  body: ReactNode;
}

/**
 * Shared visual shell for the WebAuthn ceremony pages (login + register,
 * popup + redirect). Renders a centered card plus a footer with the shared
 * Impressum / Datenschutz links so every ceremony surface exposes them.
 *
 * @param props - See {@link CeremonyChromeProps}.
 * @returns The ceremony chrome element.
 */
export function CeremonyChrome({ title, body }: CeremonyChromeProps): ReactNode {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '24px',
        fontFamily: 'system-ui, sans-serif',
        background: '#fafafa',
      }}
    >
      <div
        style={{
          maxWidth: '360px',
          width: '100%',
          padding: '24px',
          borderRadius: '12px',
          background: '#ffffff',
          boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        }}
      >
        <h1 style={{ fontSize: '20px', marginBottom: '16px', color: '#1a1a1a' }}>{title}</h1>
        {body}
      </div>
      <LegalLinks
        language={pick_locale()}
        aria_label="Rechtliches"
        style={{ display: 'flex', gap: '16px', fontSize: '12px' }}
        link_style={{ color: '#545454', textDecoration: 'none' }}
      />
    </div>
  );
}
